// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__xVbEC","pageButton":"CustomPagination_pageButton__yw4jv"};